export default {
  path: '/distribution',
  name: 'distribution',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '分销列表',
    // keepAlive: false
  },
  children: [
    {
      // 分销列表
      path: 'distributionListIndex',
      name: 'distributionListIndex',
      component: () => import('../../views/DistributionList/DistributionListIndex'),
      meta: { title: '分销列表', keepAlive: false }
    },
    {
      // 分销列表-话费预存分佣(运营商)
      path: 'PhoneBillPrestoreCommissionOperator',
      name: 'PhoneBillPrestoreCommissionOperator',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/PhoneBillPrestoreCommissionOperator'),
      meta: { title: '话费预存分佣(运营商)', keepAlive: false }
    },
    {
      // 分销列表-话费预存分佣(代理商)
      path: 'PhoneBillPrestoreCommissionAgent',
      name: 'PhoneBillPrestoreCommissionAgent',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/PhoneBillPrestoreCommissionAgent'),
      meta: { title: '话费预存分佣(代理商)', keepAlive: false }
    },
    {
      // 分销列表-靓号分佣(运营商)
      path: 'PhoneNumberCommissionOperator',
      name: 'PhoneNumberCommissionOperator',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/PhoneNumberCommissionOperator'),
      meta: { title: '靓号分佣(运营商)', keepAlive: false }
    },
    {
      // 分销列表-靓号分佣(代理商)
      path: 'PhoneNumberCommissionAgent',
      name: 'PhoneNumberCommissionAgent',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/PhoneNumberCommissionAgent'),
      meta: { title: '靓号分佣(代理商)', keepAlive: false }
    },
    {
      // 分销列表-话费分佣(运营商)
      path: 'PhoneFeeCommissionOperator',
      name: 'PhoneFeeCommissionOperator',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/PhoneFeeCommissionOperator'),
      meta: { title: '话费分佣(运营商)', keepAlive: false }
    },
    {
      // 分销列表-话费分佣(代理商)
      path: 'PhoneFeeCommissionAgent',
      name: 'PhoneFeeCommissionAgent',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/PhoneFeeCommissionAgent'),
      meta: { title: '话费分佣(代理商)', keepAlive: false }
    },
    {
      // 分销列表-套餐/产品分佣(运营商)
      path: 'PackageProductCommissionOperator',
      name: 'PackageProductCommissionOperator',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/PackageProductCommissionOperator'),
      meta: { title: '套餐/产品分佣(运营商)', keepAlive: false }
    },
    {
      // 分销列表-套餐/产品分佣(代理商)
      path: 'PackageProductCommissionAgent',
      name: 'PackageProductCommissionAgent',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/PackageProductCommissionAgent'),
      meta: { title: '套餐/产品分佣(代理商)', keepAlive: false }
    },
    {
      // 分销列表-激活奖励佣金(运营商)
      path: 'ActivateBonusCommissionOperator',
      name: 'ActivateBonusCommissionOperator',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/ActivateBonusCommissionOperator'),
      meta: { title: '激活奖励佣金(运营商)', keepAlive: false }
    },
    {
      // 分销列表-激活奖励佣金(代理商)
      path: 'ActivateBonusCommissionAgent',
      name: 'ActivateBonusCommissionAgent',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/ActivateBonusCommissionAgent'),
      meta: { title: '激活奖励佣金(代理商)', keepAlive: false }
    },
    {
      // 分销列表-设备补贴(运营商)
      path: 'EquipmentSubsidyOperator',
      name: 'EquipmentSubsidyOperator',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/EquipmentSubsidyOperator'),
      meta: { title: '设备补贴(运营商)', keepAlive: false }
    },
    {
      // 分销列表-设备补贴(代理商)
      path: 'EquipmentSubsidyAgent',
      name: 'EquipmentSubsidyAgent',
      hidden: true,
      component: () => import('../../views/DistributionList/Type/EquipmentSubsidyAgent'),
      meta: { title: '设备补贴(代理商)', keepAlive: false }
    }
  ]
}